/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum JobStatus {
    CREATED = 'created',
    QUEUED = 'queued',
    RUNNING = 'running',
    SUCCESS = 'success',
    FAILURE = 'failure',
    CANCELLED = 'cancelled',
}
